import React from 'react';
import { Sparkles } from 'lucide-react';
import { ShareableQuote } from './ShareableQuote';

export const AffirmationCard = ({ affirmation }) => {
  return (
    <div 
      data-testid="affirmation-card"
      className="my-10 p-6 md:p-8 bg-gradient-to-r from-gold-light/40 to-gold-light/20 rounded-2xl border border-gold/20 animate-fade-in"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Sparkles className="w-5 h-5 text-gold" />
          <span className="text-sm font-medium text-gold uppercase tracking-wider">
            Affirmation
          </span>
        </div>
        <ShareableQuote quote={affirmation} type="affirmation" />
      </div>
      <p className="font-accent text-2xl md:text-3xl text-charcoal leading-relaxed">
        "{affirmation}"
      </p>
    </div>
  );
};
